<template>
    <div class="flex gap-2">
        <Button
            @click="clearFilter"
            v-if="typeof selectedEventType === 'string'"
            variant="outline"
            ><XIcon :size="16"
        /></Button>

        <Select
            :model-value="selectedEventType"
            @update:model-value="showByEventType"
        >
            <SelectTrigger>
                <SelectValue
                    class="px-2"
                    :placeholder="$t('team_reports.reservations_by_event')"
                />
            </SelectTrigger>
            <SelectContent>
                <SelectGroup>
                    <SelectItem
                        v-for="eventType of eventTypes"
                        :key="eventType.id"
                        class="gap-3 px-4"
                        :value="eventType.id.toString()"
                    >
                        {{ eventType.name }}
                    </SelectItem>
                </SelectGroup>
            </SelectContent>
        </Select>
    </div>
</template>

<script setup lang="ts">
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

import { Button } from "@/components/ui/button";
import { EventType } from "../../EventTypes/types/EventType";
import { XIcon } from "lucide-vue-next";

defineProps<{
    eventTypes: EventType[];
    teamId: number;
    selectedEventType?: string;
}>();

const emit = defineEmits(["update:selectedEventType"]);

const showByEventType = (eventTypeId: string) => {
    emit("update:selectedEventType", eventTypeId);
};

function clearFilter() {
    emit("update:selectedEventType", undefined);
}
</script>
